'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import type { GuardaEtapas, SelfStep } from '../types';
const PARAM_ETAPA = 'etapa';
const STEP_TO_SLUG: Record<SelfStep, string | null> = {
  inicio: null,
  cadastro: 'cadastro',
  revisao: 'revisao',
  trocarPlano: 'trocar-plano',
  pagamento: 'pagamento',
  termos: 'termos'
};
const SLUG_TO_STEP: Record<string, SelfStep> = {
  cadastro: 'cadastro',
  revisao: 'revisao',
  'trocar-plano': 'trocarPlano',
  pagamento: 'pagamento',
  termos: 'termos'
};
const ETAPAS_QUE_EMPILHAM_HISTORICO: readonly SelfStep[] = ['termos'];
const resolverEtapa = (slug: string | null, guarda: GuardaEtapas): SelfStep => {
  const pedida: SelfStep = slug ? SLUG_TO_STEP[slug] ?? 'inicio' : 'inicio';
  if (pedida === 'inicio' || pedida === 'cadastro' || pedida === 'termos') return pedida;
  if (!guarda.temLead) {
    guarda.aoExpirarSessao();
    return 'cadastro';
  }
  if (pedida === 'pagamento' && !guarda.pagamentoIniciado) return 'revisao';
  return pedida;
};

// TODO: promover o motor de sincronização step↔URL (idêntico ao de
// negociacaoSelf/hooks/useSelfStepUrl.ts) para shared/hooks, parametrizado por
// stepToSlug/slugToStep/resolverEtapa/etapasQueEmpilhamHistorico.
export const useSelfStepUrl = (step, irParaEtapa, guarda) => {
  const $ = _c(12);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get(PARAM_ETAPA);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const slugAtual = t0;
  const stepAnteriorRef = useRef(null);
  const slugAnteriorRef = useRef(null);
  const guardaRef = useRef(guarda);
  let t1;
  if ($[2] !== guarda) {
    t1 = () => {
      guardaRef.current = guarda;
    };
    $[2] = guarda;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t1);
  let t2;
  let t3;
  if ($[4] !== irParaEtapa || $[5] !== pathname || $[6] !== router || $[7] !== searchParams || $[8] !== slugAtual || $[9] !== step) {
    t2 = () => {
      const primeiraExecucao = stepAnteriorRef.current === null;
      const stepAnterior = stepAnteriorRef.current;
      const slugAnterior = slugAnteriorRef.current;
      stepAnteriorRef.current = step;
      slugAnteriorRef.current = slugAtual;
      if (primeiraExecucao) {
        const etapaInicial = resolverEtapa(slugAtual, guardaRef.current);
        if (etapaInicial !== step) {
          irParaEtapa(etapaInicial);
        }
        return;
      }
      const slugMudou = slugAnterior !== slugAtual;
      const stepMudou = stepAnterior !== step;
      if (slugMudou && !stepMudou) {
        if (STEP_TO_SLUG[step] !== slugAtual) {
          irParaEtapa(resolverEtapa(slugAtual, guardaRef.current));
        }
        return;
      }
      if (!stepMudou) {
        return;
      }
      const slugDesejado = STEP_TO_SLUG[step];
      if (slugDesejado === slugAtual) {
        return;
      }
      const params = new URLSearchParams(searchParams.toString());
      if (slugDesejado) {
        params.set(PARAM_ETAPA, slugDesejado);
      } else {
        params.delete(PARAM_ETAPA);
      }
      const query = params.toString();
      const url = query ? `${pathname}?${query}` : pathname;
      if (ETAPAS_QUE_EMPILHAM_HISTORICO.includes(step)) {
        router.push(url, {
          scroll: false
        });
        return;
      }
      router.replace(url, {
        scroll: false
      });
    };
    t3 = [step, slugAtual, searchParams, pathname, router, irParaEtapa];
    $[4] = irParaEtapa;
    $[5] = pathname;
    $[6] = router;
    $[7] = searchParams;
    $[8] = slugAtual;
    $[9] = step;
    $[10] = t2;
    $[11] = t3;
  } else {
    t2 = $[10];
    t3 = $[11];
  }
  useEffect(t2, t3);
};